// src/modules/coding-opportunities3/IAsystem/mappers/labs.flatten.js

function pick(obj, keys) {
  for (const k of keys) {
    const v = obj?.[k];
    if (v !== undefined && v !== null && String(v).trim() !== "") return v;
  }
  return "";
}

export function flattenLabsToText(labs = []) {
  const arr = Array.isArray(labs) ? labs : [];
  return arr
    .map((l, i) => {
      const id = l.id ?? l.labId ?? `lab_${i}`;
      const date = pick(l, ["resultDate", "collectedDate", "date", "datetime"]);
      const test = pick(l, ["testName", "test", "name"]);
      const value = pick(l, ["resultValue", "result", "value"]);
      const unit = pick(l, ["unit", "units"]);
      const flag = pick(l, ["flag", "abnormalFlag", "status"]);
      return (
        `--- LAB START ---\n` +
        `lab_id: ${id}\n` +
        `date: ${date}\n` +
        `test: ${test}\n` +
        `value: ${value}\n` +
        `unit: ${unit}\n` +
        `flag: ${flag}\n` +
        `raw: ${JSON.stringify(l)}\n` +
        `--- LAB END ---\n`
      );
    })
    .join("\n");
}
